// shared HOC
import { withCartForm } from 'components/account/Plans/Cart'

// presentational component specific to registration
import UI from './UI'

// redirect to payment after saving cart and send event to GTM
export default withCartForm({
  onSuccess: data => {
    window.dataLayer && window.dataLayer.push({ event: 'register.saveCart' })
  },
  redirect: '/payment'
})(UI)
